import React, { useState } from 'react';
import cn from 'clsx';
import { Modal, Typography } from 'common/components';
import { ChevronRightIcon } from '@fronton/icons-react';
import { createElementKey, removeSpecialCharacters } from 'utils';
import { KITCHEN_ELEMENT_BLOCK } from 'landings/kitchen/kitchen-constants';
import { analyticsUtils } from 'utils/analytics-utils';
import {
  newKitchenHeaderCardGrid,
  newKitchenHeaderCardGridA,
  newKitchenHeaderCardGridB,
  newKitchenHeaderCardGridC,
  newKitchenHeaderCardItem,
  newKitchenHeaderCardItemContent,
  newKitchenHeaderCardItemIcon,
  newKitchenHeaderCardItemIconWrapper,
  newKitchenHeaderCardItemImage,
  newKitchenHeaderCardItemImageA,
  newKitchenHeaderCardItemText,
  newKitchenHeaderCardItemTextA,
  newKitchenHeaderCardItemTextB,
  newKitchenHeaderCardModal,
} from './new-kitchen-header-card-styles';
import { HEADER_CARD_LIST_A, HEADER_CARD_LIST_B, HeaderCardStructure } from './new-kitchen-header-card-constants';

type HeaderCardProps = {
  experimentCookie: string;
  signUpHref: string;
}

const NEW_KITCHEN_CARD_GRID_MAP: Record<string, string> = {
  'A': newKitchenHeaderCardGridA,
  'B': newKitchenHeaderCardGridB,
  'C': newKitchenHeaderCardGridC,
}

export const NewKitchenHeaderCard: React.FC<HeaderCardProps> = ({ experimentCookie, signUpHref }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [activeItem, setActiveItem] = useState<HeaderCardStructure | null>(null);
  const cardList = experimentCookie === 'A' ? HEADER_CARD_LIST_A : HEADER_CARD_LIST_B;

  const handleItemClick = (item: HeaderCardStructure) => () => {
    setActiveItem(item);
    setIsModalOpen(true);

    analyticsUtils.clickButtonEvent(
      KITCHEN_ELEMENT_BLOCK,
      removeSpecialCharacters(item.text),
      'Кухни под ваши размеры'
    );

    analyticsUtils.sendEvent('GA:show', {
      elementType: 'block',
      elementBlock: KITCHEN_ELEMENT_BLOCK,
      elementText: `${removeSpecialCharacters(item.text)} / modal`,
      elementName: 'Модальное окно',
    });
  };

  return (
    <>
      <ul className={cn(newKitchenHeaderCardGrid, NEW_KITCHEN_CARD_GRID_MAP[experimentCookie])}>
        {cardList.map((item, index) => (
          <li key={createElementKey('header-item', index)}>
            <button className={newKitchenHeaderCardItem} onClick={handleItemClick(item)}>
              <img
                className={
                  cn(newKitchenHeaderCardItemImage, { [newKitchenHeaderCardItemImageA]: experimentCookie === 'A' })
                }
                src={item.icon.src}
                alt={item.icon.alt}
                width="36"
                height="36"
              />
              <div className={newKitchenHeaderCardItemContent}>
                <Typography
                  className={cn(
                    newKitchenHeaderCardItemText,
                    experimentCookie === 'A' ? newKitchenHeaderCardItemTextA : newKitchenHeaderCardItemTextB
                  )}
                  variant="m"
                  size="body_long"
                >
                  {item.text}
                </Typography>
                <div className={newKitchenHeaderCardItemIconWrapper}>
                  <ChevronRightIcon
                    className={newKitchenHeaderCardItemIcon}
                    type="outline"
                    size="l"
                    color="text-minor"
                  />
                </div>
              </div>
            </button>
          </li>
        ))}
      </ul>

      {
        activeItem && (
          <Modal
            className={newKitchenHeaderCardModal}
            onClose={() => setIsModalOpen(false)}
            show={isModalOpen}
            size="m"
            variant="curtain">
            <activeItem.modal onCloseModal={() => setIsModalOpen(false)} signUpHref={signUpHref} />
          </Modal>
        )
      }
    </>
  )
}
